import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import emailjs from 'emailjs-com';
import { useParams } from 'react-router-dom';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';

import InformativaPrivacy from '../../privacyPolicy/index';

import '../../../styles/contatti.css';

export default function ContactUs() {

	const ref = useRef(null);
	const { servizioID } = useParams();
	const [from_name, setFrom_name] = useState(false);
	const [from_surname, setFrom_surname] = useState(false);
	const [from_mail, setFrom_mail] = useState(false);
	const [phone, setPhone] = useState(false);
	const [subject, setSubject] = useState(false);
	const [message, setMessage] = useState(false);
	const [urlPage, setUrlPage] = useState(window.location.pathname)
	const [urlHref, setUrlHref] = useState(window.location.href)
	
	const [checked, setChecked] = React.useState(true);

	const [selectorQ, setSelectorQ] = useState(false);

	const handleChange = (event) => {
		setChecked(event.target.checked);
	};

	const [templateEmail, setTemplateEmail] = useState(false)

	useEffect(() => {
		// 👇️ use a ref (best)
		// const el2 = ref.current;
		// console.log(el2);
	
		// 👇️ use document.querySelector()
		// should only be used when you can't set a ref prop on the element
		// (you don't have access to the element)
		setSelectorQ(ref.current)
		
	});

	useEffect(
		() => {
			const testo = `
				<p>Contact Form del sito ${urlHref}</p>
				<p>NOME: ${from_name}</p>
				<p>COGNOME: ${from_surname}</p>
				<p>MAIL: ${from_mail} </p>
				<p>TELEFONO: ${phone}</p>
				<p>MESSAGGIO: ${message}</p>
			`

			setTemplateEmail(testo)
		},
	);

	useEffect(
		() => {
			if (urlPage.includes('preventivo')) {
				setSubject(`${servizioID} - preventivo | Notaio Treviso`)
			}
			if (urlPage.includes('informazioni')) {
				setSubject(`${servizioID} - informazioni | Notaio Treviso`)
			}

		},
		[]
	);

	function sendEmail(e) {

		e.preventDefault();



		if (from_name && from_surname && from_mail && message && phone) {

			if (!checked) {
				alert(`Prima di inviare la richiesta si prega di accettare l'informativa sulla privacy.\n\nStudio Notarile Falcinelli`)
			}
			else {
				console.log(selectorQ);
				// emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, e.target, process.env.REACT_APP_EMAILJS_USER_ID)
				emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, selectorQ, process.env.REACT_APP_EMAILJS_USER_ID)

				.then((result) => {
					alert('Messaggio inviato. Grazie per aver contattato lo Studio Notarile Falcinelli!');
					window.location.reload();
				},

					(error) => {
						console.log(error.text);
					});
			}

		}

		else {
			alert('Attenzione si prega di compilare i campi obbligatori (nome, cognome, email, telefono, messaggio). Grazie!\n\nStudio Notarile Falcinelli');
		}
	}

	return (
		<>
			<p className='mt-3 text-center'>
				I campi contrassegnati con asterisco (*) sono obbligatori. Gli altri sono facoltativi.
			</p>
			<p className='text-center'>
				<strong>
					Lo Studio Notarile Falcinelli a Treviso è lieto di esaudire le vostre richieste e di venire incontro alle vostre esigenze per questo non esistate a contattarci.
				</strong>
			</p>
			
			<form onSubmit={sendEmail} id="form">
				<div className="field">
					<label className='customLab' >Nome *</label>
					<input type="text" placeholder="Nome*" name="from_name" id="from_name" onChange={e => setFrom_name(e.target.value)} />
				</div>
				<div className="field">
					<label className='customLab' >Cognome *</label>
					<input type="text" placeholder="Cognome*" name="from_surname" id="from_surname" onChange={e => setFrom_surname(e.target.value)} />
				</div>
				<div className="field">
					<label className='customLab' >Email *</label>
					<input type="email" placeholder="Email*" name="from_mail" id="from_mail" onChange={e => setFrom_mail(e.target.value)} />
				</div>
				<div className="field">
					<label className='customLab' >Telefono *</label>
					<input type="tel" placeholder="Telefono*" name="phone" id="phone" onChange={e => setPhone(e.target.value)} />
				</div>

				<div className="field">
					{urlPage.includes('preventivo')
						? 
						<input type="text" style={{ display: "none" }} placeholder="Oggetto" name="subject" id="subject" value={subject} />
						// <span>OGGETTO DELLA MAIL: <label for="subject">{subject}</label></span>
						:
						(urlPage.includes('informazioni')
							? 
							<input type="text" style={{ display: "none" }} placeholder="Oggetto" name="subject" id="subject" value={subject} />
							// <span>OGGETTO DELLA MAIL: <label for="subject">{subject}</label></span>
							:
							<>
								<label className='customLab' >Oggetto</label>
								<input type="text" placeholder="Oggetto" name="subject" id="subject" onChange={e => setSubject(e.target.value)} />
							</>
							
						)
					}
				</div>

				<div className="field">
					<label className='customLab' >Messaggio</label>
					<textarea className="message-field" type="textarea" placeholder="Messaggio" name="message" id="message" onChange={e => setMessage(e.target.value)} />
				</div>

				<MDBRow>
					<InformativaPrivacy
						checked={checked}
						handleChange={handleChange} />
				</MDBRow>
				<MDBRow className='text-center'>
					<MDBCol>
						<button
							className="button button-a button-big button-rouded"
							type="submit"
							value="Invia"
							id="button"
						>Invia</button>
					</MDBCol>
				</MDBRow>



			</form >
			<form style={{display:'none'}} ref={ref} id="FinalForm">
				<input type="text" value={from_name} name="UserName" id="UserName"/>
				<input type="text" value={from_surname} name="UserSurname" id="UserSurname" />
				<input type="mail" value={from_mail} name="UserMail" id="UserMail"/>
				<input type="text" value={urlHref} name="UrlSite" id="UrlSite"/>
				<input type="text" value={templateEmail} name="CorpusText" id="CorpusText" />
			</form>
		</>
	);
}

